import axios from 'axios';

import { BankAccountVerificationSuccessEvent, WidgetUrlResponse } from '../domain/bank-account-linking';

const getAccountLinkingWidgetUrl = (): Promise<string> => {
  return axios
    .get<WidgetUrlResponse>('/qualification/account_linking/widget_url')
    .then((res) => res.data)
    .then((data) => data.url);
};

const notifyBankAccountConnected = (event: BankAccountVerificationSuccessEvent): Promise<void> => {
  return axios.post('/qualification/account_linking/connected', event);
};

export { getAccountLinkingWidgetUrl, notifyBankAccountConnected };
